<template>
    <v-row dense>
        <v-tabs v-model="tabEnt">
            <v-tabs-slider></v-tabs-slider>
            <v-tab href="#tabEnt-1">
                <v-icon left>mdi-moped</v-icon>
                Entrega
            </v-tab>
            <v-tab href="#tabEnt-2">
                <v-icon left>mdi-store</v-icon>
                Retirada
            </v-tab>
            <v-tab href="#tabEnt-3">
                <v-icon left>mdi-comment-account</v-icon>
                Geral
            </v-tab>      
        </v-tabs>                
        <v-tabs-items v-model="tabEnt">
            <v-tab-item :key="11" :value="'tabEnt-1'">
                <v-row dense align="center" align-content="center" justify="center">
                    <v-col cols="12">
                        <v-card class="mx-auto">
                            <v-card-text dense class="pt-0 pb-0">                            
                                <v-row dense align="center" align-content="center" justify="center">
                                    <v-col cols="9">
                                        <span class="title ml-3"> Entrega </span> <br/>
                                        <span class="body-2 ml-3"> A opção de Entrega de seus Pedidos está <span :class="(quoonEntrega)?'font-weight-bold green--text':'font-weight-bold red--text'">{{(quoonEntrega)?'Ativo':'Inativo'}}</span>   </span>                                
                                    </v-col>
                                    <v-spacer></v-spacer>
                                    <v-col cols="3">
                                        <v-switch v-model="quoonEntrega" :label="(quoonEntrega)?'Ativo':'Inativo'" :color="(quoonEntrega)?'green':'red'" @change="saveConfig('quoonEntrega',quoonEntrega)">
                                        </v-switch>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>   
                    </v-col>  
                    <v-col cols="6">
                        <v-card class="mx-auto">
                            <v-card-text dense class="pt-0 pb-0">
                                <v-row dense align="center" align-content="center" justify="center">
                                    <v-col cols="6">
                                        <span class="title"> Taxa de Entrega </span> <br/>
                                        <span class="body-2"> Taxa aplicada para entrega do pedido</span>
                                    </v-col>                    
                                    <v-spacer></v-spacer>
                                    <v-col cols="4">
                                        <v-select v-model="taxaEntrega" :items="items"></v-select>
                                    </v-col> 
                                    <v-col cols="2">
                                        <v-btn color="primary" fab small dark @click="saveConfig('taxaEntrega',taxaEntrega)">
                                            <v-icon>mdi-content-save</v-icon>
                                        </v-btn>                                                                                 
                                    </v-col>                                                                                            
                                </v-row>
                            </v-card-text>
                        </v-card>                        
                    </v-col> 
                    <v-col cols="6">
                        <v-card class="mx-auto">
                            <v-card-text dense class="pt-0 pb-0">
                                <v-row dense align="center" align-content="center" justify="center">
                                <v-col cols="6">
                                    <span class="title"> Prazo de Entrega </span> <br/>
                                    <span class="body-2"> Prazo estimado para a entrega (em minutos)</span>
                                </v-col>
                                <v-col cols="6">
                                    <v-row align="center" align-content="center" justify="center">
                                        <v-col cols="3">
                                            <v-text-field v-model="pe1" label="De" type="number" hide-details min=0></v-text-field>
                                        </v-col>
                                        <v-col cols="3">
                                            <v-text-field v-model="pe2" label="à" type="number" hide-details min=0></v-text-field>
                                        </v-col> 
                                        <v-col cols="6">
                                            <v-btn color="primary" fab small dark @click="savePrazo">
                                                <v-icon>mdi-content-save</v-icon>
                                            </v-btn>                                                                                 
                                        </v-col>                                        
                                    </v-row>                                    
                                </v-col>                                
                                <v-spacer></v-spacer>                                                           
                                </v-row>
                            </v-card-text>
                        </v-card>                        
                    </v-col>                                        
                    <v-col cols="12">
                        <v-card class="mx-auto">
                            <v-card-text dense class="pt-0 pb-0">
                                <v-row dense align="center" align-content="center" justify="center">
                                <v-col cols="6">
                                    <span class="title"> Exigir pedido mínimo para Entrega? </span> <br/>
                                    <span class="body-2"> A opção de restringir o valor do pedido para Entrega está: <span :class="(quoonEntregaMin)?'font-weight-bold green--text':'font-weight-bold red--text'">{{(quoonEntregaMin)?'Ativo':'Inativo'}}</span>   </span>
                                </v-col>
                                <v-col cols="4">
                                    <v-row dense align="center" align-content="center" justify="center">
                                        <v-col cols="5" class="pl-0">
                                              <v-text-field v-model="pedidoMin"
                                                     v-money="money"
                                                     solo
                                                     dense
                                                     outlined
                                                     hide-details
                                                     class="form-input input-lg"
                                                     style="text-align: right" />
                                        </v-col>
                                        <v-col cols="6">
                                            <v-btn color="primary" fab small dark @click="saveConfig('pedidoMin',pedidoMin)">
                                                <v-icon>mdi-content-save</v-icon>
                                            </v-btn>                                                                                 
                                        </v-col>
                                        <v-spacer></v-spacer>
                                    </v-row>                                    
                                </v-col>                                
                                <v-spacer></v-spacer>
                                <v-col cols="2">
                                        <v-switch v-model="quoonEntregaMin" :label="(quoonEntregaMin)?'Ativo':'Inativo'" :color="(quoonEntregaMin)?'green':'red'" @change="saveConfig('quoonEntregaMin',quoonEntregaMin)">
                                        </v-switch>
                                </v-col>                                                            
                                </v-row>
                            </v-card-text>
                        </v-card>                        
                    </v-col>  
                    <v-col cols="12">
                        <v-card class="mx-auto">
                            <v-card-text dense class="pt-0 pb-0">
                                <v-row dense align="center" align-content="center" justify="center">
                                <v-col cols="6">
                                    <span class="title"> Disponibilizar Entrega Grátis? </span> <br/>
                                    <span class="body-2"> A opção de entrega grátis para pedidos acima de Determinado Valor está: <span :class="(quoonEntregaFree)?'font-weight-bold green--text':'font-weight-bold red--text'">{{(quoonEntregaFree)?'Ativo':'Inativo'}}</span>   </span>
                                </v-col>
                                <v-col cols="4">
                                    <v-row dense align="center" align-content="center" justify="center">
                                        <v-col cols="5" class="pl-0">
                                              <v-text-field v-model="valEntGratis"
                                                     v-money="money"
                                                     solo
                                                     dense
                                                     outlined
                                                     hide-details
                                                     class="form-input input-lg"
                                                     style="text-align: right" />      
                                        </v-col>
                                        <v-col cols="6">
                                            <v-btn color="primary" fab small dark @click="saveConfig('valEntGratis',valEntGratis)">
                                                <v-icon>mdi-content-save</v-icon>
                                            </v-btn>                                                                                    
                                        </v-col>
                                        <v-spacer></v-spacer>
                                    </v-row>                                    
                                </v-col>                                
                                <v-spacer></v-spacer>
                                <v-col cols="2">
                                        <v-switch v-model="quoonEntregaFree" :label="(quoonEntregaFree)?'Ativo':'Inativo'" :color="(quoonEntregaFree)?'green':'red'"  @change="saveConfig('quoonEntregaFree',quoonEntregaFree)">
                                        </v-switch>
                                </v-col>                                                            
                                </v-row>
                            </v-card-text>
                        </v-card>                        
                    </v-col> 
                    <!-- Falta -->
                    <v-col cols="12">
                        <v-card class="mx-auto">
                            <v-card-text dense class="pt-0 pb-0">
                                <v-row dense align="center" align-content="center" justify="center">
                                <v-col cols="5">
                                    <span class="title"> Permitir agendamento da Entrega? </span> <br/>
                                    <span class="body-2"> A opção de agendamento para entrega do produto ou serviço está: <span :class="(quoonEntregaSch)?'font-weight-bold green--text':'font-weight-bold red--text'">{{(quoonEntregaSch)?'Ativo':'Inativo'}}</span>   </span>
                                </v-col>
                                <v-col cols="5">
                                    <v-row dense align="center" align-content="center" justify="center">
                                        <v-col cols="3" class="pl-0">
                                            <v-text-field v-model="schedule" type="number" solo dense outlined hide-details min="0" ></v-text-field>
                                        </v-col>
                                        <v-col cols="3" class="text-right">
                                            <v-select v-model="ttime" :items="typetime"></v-select>
                                        </v-col>                                                
                                        <v-col cols="6">
                                            <v-btn color="primary" fab small dark >
                                                <v-icon>mdi-content-save</v-icon>
                                            </v-btn>                                                                                 
                                        </v-col>
                                        <v-spacer></v-spacer>
                                    </v-row>                                    
                                </v-col>                                
                                <v-spacer></v-spacer>
                                <v-col cols="2">
                                        <v-switch v-model="quoonEntregaSch" :label="(quoonEntregaSch)?'Ativo':'Inativo'" :color="(quoonEntregaSch)?'green':'red'" @change="saveConfig('quoonEntregaSch',quoonEntregaSch)">
                                        </v-switch>
                                </v-col>                                                            
                                </v-row>
                            </v-card-text>
                        </v-card>                        
                    </v-col>                                                                                      
                </v-row>                        
            </v-tab-item>
            <v-tab-item :key="12" :value="'tabEnt-2'">
                <v-row dense align="center" align-content="center" justify="center">
                    <!-- Retirada -->   
                    <v-col cols="12">
                        <v-card class="mx-auto">
                            <v-card-text dense class="pt-0 pb-0">                            
                                <v-row dense align="center" align-content="center" justify="center">
                                    <v-col cols="4">
                                        <span class="title ml-3"> Permitir Retirada no Local? </span> <br/>
                                        <span class="body-2 ml-3"> A opção de retirada no estabelecimento está <span :class="(quoonRetira)?'font-weight-bold green--text':'font-weight-bold red--text'">{{(quoonRetira)?'Ativo':'Inativo'}}</span>   </span>                                
                                    </v-col>
                                    <v-col cols="6" >
                                        <v-row dense align="center" align-content="center" justify="center">
                                            <v-col cols="4" class="text-right">
                                                <span class="title"> Retirada em: </span> <br/>
                                                <span class="body-2 ml-3"> Insira o valor em minutos </span>
                                            </v-col>
                                            <v-col cols="3">
                                                <v-text-field v-model="tempoRetirada" solo dense outlined hide-details ></v-text-field>
                                            </v-col>
                                            <v-col cols="3">
                                                <v-btn color="primary" fab small dark>
                                                    <v-icon>mdi-content-save</v-icon>
                                                </v-btn>                                                                             
                                            </v-col>
                                            <v-spacer></v-spacer>
                                        </v-row>                                    
                                    </v-col>                                                                    
                                    <v-col cols="2">
                                        <v-switch v-model="quoonRetira" :label="(quoonRetira)?'Ativo':'Inativo'" :color="(quoonRetira)?'green':'red'" @change="saveConfig('quoonRetira',quoonRetira)">
                                        </v-switch>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>   
                    </v-col>  
                    <v-col cols="12">
                        <v-card class="mx-auto">
                            <v-card-text dense class="pt-0 pb-0">
                                <v-row dense align="center" align-content="center" justify="center">
                                <v-col cols="6">
                                    <span class="title"> Oferecer Desconto para Retirada no Local? </span> <br/>
                                    <span class="body-2"> A opção de desconto para retirada no local está <span :class="(quoonEntregaLocal)?'font-weight-bold green--text':'font-weight-bold red--text'">{{(quoonEntregaLocal)?'Ativo':'Inativo'}}</span>   </span>
                                </v-col>
                                <v-col cols="4">
                                    <v-row dense align="center" align-content="center" justify="center">
                                        <v-col cols="5" class="pl-0">
                                            <v-text-field v-model="descRetLocal"
                                                    v-money="percent"
                                                    solo
                                                    dense
                                                    outlined
                                                    hide-details
                                                    class="form-input input-lg"
                                                    style="text-align: right" />     
                                            <!-- <v-text-field v-model="descRetLocal" solo dense outlined hide-details ></v-text-field> -->
                                        </v-col>
                                        <v-col cols="6">
                                            <v-btn color="primary" fab small dark>
                                                <v-icon>mdi-content-save</v-icon>
                                            </v-btn>                                                                                                                               
                                        </v-col>
                                        <v-spacer></v-spacer>
                                    </v-row>                                    
                                </v-col>                                
                                <v-spacer></v-spacer>
                                <v-col cols="2">
                                        <v-switch v-model="quoonEntregaLocal" :label="(quoonEntregaLocal)?'Ativo':'Inativo'" :color="(quoonEntregaLocal)?'green':'red'" @change="saveConfig('quoonEntregaLocal',quoonEntregaLocal)">
                                        </v-switch>
                                </v-col>                                                            
                                </v-row>
                            </v-card-text>
                        </v-card>                        
                    </v-col>                             
                </v-row>
            </v-tab-item>
        </v-tabs-items>    
    </v-row>
</template>
<script>
import {db} from '@/main'
import dbFunctions from "@/dbFunctions"
import store from "@/store"
  import {VMoney} from 'v-money'

    export default {
        data: () => ({
            money: {
                decimal: ',',
                thousands: '',
                prefix: 'R$ ',
                // suffix: ' #',
                precision: 2,
                masked: true
            },    
            percent: {
                decimal: ',',
                thousands: '',
                // prefix: 'R$ ',
                suffix: ' %',
                precision: 2,
                masked: false
            },                     
            tabEnt: "tabEnt-1",
            descRetLocal: 0,
            tempoRetirada: 0,
            ttime: 'Minutos',
            typetime: ['Minutos','Horas','Dias'],
            schedule: 0,
            valEntGratis: 0,
            pedMin: 0,
            pe1: 0,
            pe2: 0,            
            quoonEntregaLocal: false,
            quoonEntregaSch: false,
            quoonEntregaFree: false,
            quoonEntregaMin: false,
            quoonEntrega: false,
            quoonRetira: false,
            taxaEntrega: 0,
            pedidoMin: 0,
        }),
        directives: {money: VMoney},
        created(){
            this.companyId = this.$store.getters.company.data.id
            this.getDataInfo = dbFunctions.getDataInfo
            this.getCompanyInfo = dbFunctions.getCompanyInfo


            this.schedule = this.$store.getters.company.data.configEntrega.schedule
            this.valEntGratis = this.$store.getters.company.data.configEntrega.valEntGratis
            this.pedMin = this.$store.getters.company.data.configEntrega.pedMin
            this.pe1 = this.$store.getters.company.data.configEntrega.pe1
            this.pe2 = this.$store.getters.company.data.configEntrega.pe2           
            this.quoonEntregaLocal = this.$store.getters.company.data.configEntrega.quoonEntregaLocal
            this.quoonEntregaSch = this.$store.getters.company.data.configEntrega.quoonEntregaSch
            this.quoonEntregaFree = this.$store.getters.company.data.configEntrega.quoonEntregaFree
            this.quoonEntregaMin = this.$store.getters.company.data.configEntrega.quoonEntregaMin
            this.quoonEntrega = this.$store.getters.company.data.configEntrega.quoonEntrega
            this.quoonRetira = this.$store.getters.company.data.configEntrega.quoonRetira
            this.taxaEntrega = this.$store.getters.company.data.configEntrega.taxaEntrega
            this.pedidoMin = this.$store.getters.company.data.configEntrega.pedidoMin           
        },
        methods: {
            savePrazo(){
                this.saveConfig('prazoEntregaIni', this.pe1, false)
                this.saveConfig('prazoEntregaFim', this.pe2)
            },
            saveConfig(item, value, showMessage = true){
                // console.log("Passou", this.$store.getters.company.data )
                let configEntrega = this.$store.getters.company.data.configEntrega || {}
                configEntrega[item] = value
                configEntrega = {
                    'configEntrega': configEntrega
                }
                console.log(configEntrega, item, value)
                db.collection('empresas').doc(this.companyId).update(configEntrega).then(async() => {
                    this.loading = false
                    let success = {
                        'active':true,
                        'color':'success',
                        'message':'Configuração Atualizada com Sucesso'
                    }                
                    await this.reloadData(this.$store.getters.company.data.id)
                    if (showMessage)
                        this.$emit("loadMessage",success)
                    // this.$emit("listEdit")
                    // this.clearFields()
                }).catch(function (error) {
                    let errorMessage = {
                        'active':true,
                        'color':'error',
                        'message': error
                    }          
                    console.error('Error to Save Config - DeliveryPage: ' + error)
                    this.$emit("loadMessage",errorMessage)
                })                
            }, 
            async reloadData(companyId){
                let dataStore = await this.getDataInfo(companyId)
                let empresa = await this.getCompanyInfo(companyId)
              
                store.dispatch("fetchData",dataStore)
                store.dispatch("fetchCompany",empresa)                                
            },  
            loadMessage(value){
                this.$emit("loadMessage", value);            
            }
        }                 
    }
</script>